import { render, staticRenderFns } from "./RegisterScreen.vue?vue&type=template&id=fa8f8fc8&"
import script from "./RegisterScreen.vue?vue&type=script&lang=js&"
export * from "./RegisterScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports